module.exports = __webpack_public_path__ + "media/images/ecalls/06_fausto_frame_cloud_top-ea0581ca9fe669b40f0f91400b4ea927.png";